export const FETCH_VIDEOS = 'FETCH_VIDEOS';
export const UPDATE_VIDEO = 'UPDATE_VIDEO'
export const DELETE_VIDEO = 'DELETE_VIDEO'

export const VIDEO_GET_VIDEO = 'VIDEO_GET_VIDEO';
